<ngb-rating [rate]="productRating"></ngb-rating>